// extracted by mini-css-extract-plugin
export var container = "_t-1";
export var copyright = "_t-3";
export var footer = "_t-0";
export var logo = "_t-2";